import { defineSlotRecipe } from "@chakra-ui/react/styled-system";

/**
 * Recipe configuration for the ModalPage component.
 * Provides a fullscreen modal page layout with a fixed grid structure:
 * top bar, header, scrollable content, and optional footer.
 */
export const modalPageSlotRecipe = defineSlotRecipe({
  slots: [
    "root",
    "topBar",
    "header",
    "title",
    "subtitle",
    "actions",
    "tabNav",
    "content",
    "footer",
  ],
  className: "nimbus-modal-page",
  base: {
    root: {
      display: "grid",
      gridTemplateRows: "auto auto 1fr auto",
      height: "100%",
      width: "100%",
    },
    topBar: {
      display: "flex",
      alignItems: "center",
      gap: "200",
      px: "600",
      py: "300",
      borderBottom: "solid-25",
      borderColor: "border",
    },
    header: {
      display: "grid",
      gridTemplateColumns: "1fr auto",
      alignItems: "center",
      px: "900",
      pt: "800",
      pb: "600",
      borderBottom: "solid-25",
      borderColor: "border",
      // Depends on the BEM class generated by the tabNav slot's className.
      // If the recipe className changes, this selector must be updated too.
      "&:has(.nimbus-modal-page__tabNav)": {
        pb: "0",
      },
    },
    title: {
      gridColumn: "1",
      textStyle: "xl",
      fontWeight: "semibold",
      color: "neutral.12",
    },
    subtitle: {
      gridColumn: "1",
      mt: "100",
      textStyle: "sm",
      color: "neutral.11",
    },
    actions: {
      gridColumn: "2",
      gridRow: "1 / span 2",
      display: "flex",
      alignItems: "center",
      gap: "200",
    },
    tabNav: {
      gridColumn: "1 / -1",
      mt: "200",
    },
    content: {
      overflow: "auto",
      // Use padding (not margin) on the scroll container so that content
      // near the edges is not clipped at the margin boundary when scrolling.
      py: "800",
      px: "900",
    },
    footer: {
      display: "flex",
      alignItems: "center",
      gap: "200",
      borderTop: "solid-25",
      borderColor: "border",
      px: "600",
      py: "400",
    },
  },
});
